import {Modal} from '@mantine/core';
import React, {useEffect, useState} from 'react';
import {useAuth} from "../../../../../../providers/AuthProvider";
import {KpiProps, KpiWithSchedulerInfo} from "../../../../../../types/types";
import "./PrefillModal.css"
import { getKpiStatus } from '../../../../../../services/kpiService';
import PrefillKPICard from '../card/PrefillKPICard';

export type ModalProps = {
    opened: boolean,
    setOpened: (flag: boolean) => void
}

export function PrefillModal(props: KpiProps & ModalProps) {
    const [kpiList, setKpiList] = useState<KpiWithSchedulerInfo[]>([]);

    const authContext = useAuth();

    //getting kpi data from api and storing it into a state varaible while first time rendering the data.
    useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, []);

    const getData = async () => {
        try {
            const kpiStatus = await getKpiStatus(authContext)
            console.log(kpiStatus)
            setKpiList(kpiStatus.contents);
        } catch (error) {
            console.log(error)
            setKpiList([])
        }
    }
    return <>
        <Modal
            className="prefillKPI-modal-container"
            opened={props.opened}
            onClose={() => props.setOpened(false)}
            radius="lg"
            size="1000px"
        >
            <div style={{height: "35rem", overflow: "auto"}}>
                <h2 className="prefillKPIModal__heading">Choose from existing KPI to prefill</h2>
                <div className="prefillKpiOptions">
                    {kpiList && kpiList.map((kpi)=>{
                        return <>
                            <PrefillKPICard 
                                key={kpi.kpiInfo.id}
                                KPICardInfo={kpi.kpiInfo}
                                closeModal={() => props.setOpened(false)}
                                {...props}
                            />
                        </>
                    })}
                </div>
            </div>
        </Modal>
    </>
}
